"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let path = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  id: "XMLID_835_",
  d: "M77.186,15.959h3.285V29.481a.483.483,0,0,0,.483.483h5.569a.483.483,0,0,0,.483-.483V16.023h3.776a.483.483,0,0,0,.48-.428l.573-4.978a.483.483,0,0,0-.48-.539H87.007V6.957c0-.941.506-1.418,1.506-1.418h2.844a.483.483,0,0,0,.483-.483V.487A.483.483,0,0,0,91.356,0H87.437c-.028,0-.089,0-.18,0a7.51,7.51,0,0,0-4.911,1.851,5.15,5.15,0,0,0-1.712,4.578v3.649H77.186a.483.483,0,0,0-.483.483v4.915A.483.483,0,0,0,77.186,15.959Z",
  transform: "translate(-76.703)",
  fill: "#ef7e3a"
}));
let viewBox = '0 0 15.136 29.965';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'FacebookIcon', viewBox);
